import { BarChart } from '@mantine/charts';
import React from 'react';

export interface ManhoursChartData {
  name: string;
  FTEs: number;
}

export interface ManhoursChartProps {
  data: ManhoursChartData[];
}

export const ManhoursChart: React.FC<ManhoursChartProps> = ({ data }) => {
  return (
    <BarChart
      h={300}
      w="100%"
      data={data}
      valueFormatter={(value) => value.toFixed(2)}
      dataKey="name"
      series={[{ name: 'FTEs', color: 'blue' }]}
      tickLine="y"
      gridAxis="xy"
      withLegend
      withTooltip
    />
  );
};
